var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"usp-skeleton"},[_vm._t("default",function(){return _vm._l((_vm.quantidade),function(n){return _c('div',{key:n,staticClass:"usp-skeleton-item"},[_c('div')])})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }